// Function to fill classifications form
export const classificationsFillForm = (item) => ({
  id: item.id,
  Image: null,
  Name: item.name,
  Order: item.order,
  IsActive: item.isActive,
  imageFullUrl: item.imageFullUrl,
  bannerFullUrl: item.bannerFullUrl,
  ShowOnHomePage: item.showOnHomePage,
  ShowOnFastDonation: item.showOnFastDonation,
});

// Function to filter classifications based on search term
export const classificationsFilter = (data, search) => {
  const lowerCaseSearch = search.toLowerCase();
  return data.filter(({ name }) =>
    name.toLowerCase().includes(lowerCaseSearch),
  );
};
